import {
  DeleteEntityEventsSiteCommandButton,
  HealthCheckCommandButton,
  PingSiteCommandButton,
  ProvisionFeatureCommandButton,
  RecalculateAvailabilityCommandButton,
  RestartSiteComponentCommandButton,
  SnapshotTablesCommandButton,
  StartSiteComponentCommandButton,
  StopSiteComponentCommandButton,
  UpdateLogLevelCommandButton,
  UploadLogsCommandButton
} from "modules/tenants/sections/pros/dashboard/site-commands";
import { ModifyDatabaseCommandButton } from "modules/tenants/sections/pros/dashboard/site-commands/ModifyDatabaseCommandButton";
import { SiteUpdateCommandButton } from "modules/tenants/sections/pros/dashboard/site-commands/SiteUpdateCommandButton";

import { Heading, Stack, useTheme } from "@bps/fluent-ui";
import { SecurableComponent } from "@components/SecurableComponent";
import { Permissions } from "@libs/permissions/permissions.enum";

import { CommandRunnerContextProvider } from "../../../../_shared-context/command-runner-context/command-runner-context.provider";
import { CommandRunnerStatusBar } from "./CommandRunnerStatusBar";
import { UpdateSecretsCommandButton } from "./site-commands/UpdateSecretsCommandButton";

interface SiteCommandsProps {
  siteId: string;
}

export const SiteCommands = ({ siteId }: SiteCommandsProps) => {
  const theme = useTheme();
  return (
    <CommandRunnerContextProvider>
      <Heading variant="heading">Site Health</Heading>
      <Stack horizontal wrap>
        <SecurableComponent permissions={[Permissions.ProsSiteManagementRead]}>
          <HealthCheckCommandButton siteId={siteId} />
          <PingSiteCommandButton siteId={siteId} />
        </SecurableComponent>
        <Stack>
          <SecurableComponent
            permissions={[Permissions.ProsSiteManagementWrite]}
            showError={false}
          >
            <Stack
              horizontal
              styles={{
                root: {
                  border: `1px solid ${theme.semanticColors.disabledBorder}`
                }
              }}
            >
              <UpdateLogLevelCommandButton siteId={siteId} />
              <UploadLogsCommandButton siteId={siteId} />
            </Stack>
          </SecurableComponent>
        </Stack>
      </Stack>

      <Heading variant="heading">Site Provisioning</Heading>
      <Stack horizontal wrap>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementProvision]}
        >
          <ModifyDatabaseCommandButton siteId={siteId} />
          <ProvisionFeatureCommandButton siteId={siteId} />
          <UpdateSecretsCommandButton siteId={siteId} />
        </SecurableComponent>
      </Stack>

      <Heading variant="heading">Site Management</Heading>
      <Stack horizontal wrap>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementWrite]}
          showError={false}
        >
          <StartSiteComponentCommandButton siteId={siteId} />
        </SecurableComponent>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementWrite]}
          showError={false}
        >
          <StopSiteComponentCommandButton siteId={siteId} />
        </SecurableComponent>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementWrite]}
          showError={false}
        >
          <RestartSiteComponentCommandButton siteId={siteId} />
        </SecurableComponent>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementProvision]}
          showError={false}
        >
          <SnapshotTablesCommandButton siteId={siteId} />
        </SecurableComponent>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementProvision]}
          showError={false}
        >
          <RecalculateAvailabilityCommandButton siteId={siteId} />
        </SecurableComponent>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementProvision]}
          showError={false}
        >
          <DeleteEntityEventsSiteCommandButton siteId={siteId} />
        </SecurableComponent>
      </Stack>

      <Heading variant="heading">Schedule Commands</Heading>
      <Stack horizontal>
        <SecurableComponent
          permissions={[Permissions.ProsSiteManagementProvision]}
        >
          <SiteUpdateCommandButton siteId={siteId} />
        </SecurableComponent>
      </Stack>
      <CommandRunnerStatusBar />
    </CommandRunnerContextProvider>
  );
};
